import { render, staticRenderFns } from "./FinalizarSolicitudComponente.vue?vue&type=template&id=0ca23d02"
import script from "./FinalizarSolicitudComponente.vue?vue&type=script&lang=js"
export * from "./FinalizarSolicitudComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports